<template>
<CRow v-if="contactModal.item.length > 0 || $policy('conversation').view_any">
    <CCol col="12" lg="3" style="min-height: 600px;overflow-y: scroll;max-height: 600px;" class="b-a-1">
        <CButton color="primary" class="btn-sm w-100 mb-2 mt-2" v-if="getContacts.length > 0" @click="openContactsModal">
            <span>گفتگوی جدید</span>
        </CButton>

        <CListGroup>
            <CListGroupItem class="cursor-pointer bg-white shadow-sm mt-2" v-for="conversation in conversations" :key="conversation.id" @click="getMessages(conversation._id)">
                {{ conversation.subject }} <span v-if="conversation.unread_count > 0" class="float-right mt-2 badge badge-danger">{{ conversation.unread_count }}</span>
            </CListGroupItem>
        </CListGroup>
    </CCol>

    <CCol col="12" lg="9" style="min-height: 600px;" class="b-a-1">
        <Details v-if="selectedConversationId !== 'NAN' && selectedConversationId !== null" class="mt-2" :conversationId="selectedConversationId" />
        <CContainer v-else-if="selectedConversationId === 'NAN'">
            <CRow>
                <CCol col="12" md="10" class="mx-auto">
                    <Loading />
                </CCol>
            </CRow>
        </CContainer>
    </CCol>

    <CModal :show.sync="contactModal.show">
        <template #header-wrapper>
            <span></span>
        </template>

        <CListGroup>
            <CListGroupItem v-for="contact in getContacts" :key="contact.id" @click="createConversation(contact.id, contact.name)" class="cursor-pointer">
                {{ contact.name }}
            </CListGroupItem>
        </CListGroup>

        <template #footer-wrapper>
            <span></span>
        </template>
    </CModal>
</CRow>
<CRow v-else>
    <CAlert color="warning" class="mt-3">
        <span v-if="$policy('store').join">شما با هیچ فروشگاهی همکاری فعال ندارید</span>
        <span v-else>شما هیچ بازاریاب در حال همکاری‌ای ندارید.</span>
    </CAlert>
</CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Details from './partials/Details.vue'

export default {
    name: 'List',

    components: {
        Details,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchContacts().then(result => {
                vm.contactModal.item = result.data
            })
        })
    },

    data() {
        return {
            contactModal: {
                item: [],
                show: false
            },
            selectedConversationId: null,
        }
    },

    computed: {
        ...mapGetters({
            conversations: 'conversation/conversations',
        }),
        getContacts() {
            // return this.contactModal.item.filter(contact => {
            //     return Object.keys(this.conversations).filter(key => ! this.conversations[key].members.includes(contact.id)).length === 0
            // })

            return this.contactModal.item
        }
    },

    methods: {
        ...mapActions({
            fetchContacts: 'conversation/fetchContacts',
            fetchMessages: 'conversation/fetchMessages',
            create: 'conversation/create',
            setShowLoading: "loadingComponent/setShowLoading",
        }),
        openContactsModal() {
            this.contactModal.show = true
        },
        createConversation(contactId, subject) {
            this.create({
                contact_id: contactId,
                subject: subject
            }).then(() => {
                this.contactModal.show = false
            })

        },
        getMessages(conversationId) {
            this.selectedConversationId = 'NAN'
            this.setShowLoading(true)
            this.fetchMessages(conversationId).then(result => {
                this.setShowLoading(false)
                this.selectedConversationId = conversationId
            })
        }
    }
}
</script>